import React from "react";
import { translation } from "utility/const";
import { Button } from "components/atomes";
import { setUser } from "data";
import { navigate } from "gatsby";
import { Auth } from "aws-amplify";

const Summary = ({ values }) => {
  const daysToMilliSecond = (days = 0) => {
    return days * 24 * 3600 * 1000;
  };

  const saveAccount = async e => {
    const user = await Auth.currentAuthenticatedUser();
    const id = user.username;
    const userInfo = {
      PK: id,
      SK: `u#${id}`,
      id,
      ...values,
      phase: values.phase[1].toString(),
      level: values.level[1].toString(),
      division: values.division[1].toString(),
      lastName: values.lastName ? values.lastName : null,
      firstName: values.firstName ? values.firstName : null,
      subType: "SILVER",
      endSub: new Date(Date.now() + daysToMilliSecond(7)).toISOString(),
      subject: values.userType === "teacher" ? values.subject : "علوم فيزيائية",
      silverStars: 100,
      goldStars: 0,
      freeSolution: new Date().toISOString(),
      tutoring: {
        confirmed: false,
        day: values.day ? values.day : null,
        time: values.time ? values.time : null,
      },
      type: "user",
    };
    await setUser(userInfo);
    values.day === "" ? navigate("/App/thankyou") : navigate("/دروس-خصوصية");
  };
  return (
    <>
      <h3>تأكد من المعلومات ثم سجل</h3>
      <div className="card--signUp">
        <h5>
          نوع المستخدم:
          {translation[values.userType]}
        </h5>
        {values.userType === "teacher" && (
          <>
            <p>
              الطور:
              {values.phase[0]}
            </p>
            <p>
              المادة:
              {values.subject}
            </p>
          </>
        )}
        {values.userType === "student" && (
          <>
            <p>
              الطور:
              {values.phase[0]}
            </p>
            <p>
              المستوى:
              {values.level[0]}
            </p>
            <p>
              الشعبة:
              {values.division[0]}
            </p>
            {values.day !== "" ? (
              <>
                <p>تم التسجيل في الدروس الخصوصية</p>
                <h3>اليوم</h3>
                <p>{values.day}</p>
                <h3>الوقت</h3>
                <p>{values.time}</p>
              </>
            ) : null}
          </>
        )}
        <p>
          اللقب:
          {values.lastName ? values.lastName : "يسجل لاحقا"}
        </p>
        <p>
          الاسم:
          {values.firstName ? values.firstName : "يسجل لاحقا"}
        </p>
        <p>
          رقم الهاتف:
          {values.phone ? values.phone : "يسجل لاحقا"}
        </p>
        <Button handelClick={saveAccount}>سجل البيانا الجديدة</Button>
      </div>
    </>
  );
};

export default Summary;
